// extracted by mini-css-extract-plugin
export default {"content":"MyAds_content__q4Ly2","paymentTitle":"MyAds_paymentTitle__2CbqN","button":"MyAds_button__KfjAS","checkbox":"MyAds_checkbox__mpiQy"};